// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export { listByStorageAccount, $delete, update, create, get } from "./operations.js";
export type {
  DataSharesListByStorageAccountOptionalParams,
  DataSharesDeleteOptionalParams,
  DataSharesUpdateOptionalParams,
  DataSharesCreateOptionalParams,
  DataSharesGetOptionalParams,
} from "./options.js";
